import React, { useContext, useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Grid, Paper, TextField } from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetClient, PostClientIntendedWorkInfo } from '../services/httpServices';

import styled from '@emotion/styled';

// import { TextField } from '@material-ui/core';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const DetailsOfWorkInCanada = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);

  const [client, setClient] = useState({});

  const fullNameRef = useRef('');
  const addressOfEmpRef = useRef('');
  const provinceOfEmpRef = useRef('');
  const cityOfEmpRef = useRef('');
  const jobTitleRef = useRef('');

  const fetchClient = async (event) => {
    const client = await GetClient(props.id);
    //console.log('client:', client);
    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);
  // #endregion Refs

  const SaveUser = async (event) => {
    // setPosting(true);
    setLoading(true);
    event.preventDefault();
    //('saveHit');
    const payload = {
      id: props.id,
      nameOfEmployer: fullNameRef.current.value,
      addressOfEmployer: addressOfEmpRef.current.value,
      provinceOfEmployment: provinceOfEmpRef.current.value,
      cityOfEmployment: cityOfEmpRef.current.value,
      jobTitle: jobTitleRef.current.value,
    };

    //console.log(payload);
    let response = await PostClientIntendedWorkInfo(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Client saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = client;
      clientSaved.clientWorkInCanadaInfos[0] = response.data;
      setClient(clientSaved);
      // setTimeout(() => {
      //   navigate(`/app/EditClient/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Name of Employer"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientWorkInCanadaInfos[0]?.nameOfEmployer}
                      inputRef={fullNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Address of Employer"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientWorkInCanadaInfos[0]?.addressOfEmployer}
                      inputRef={addressOfEmpRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Province of employment"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientWorkInCanadaInfos[0]?.provinceOfEmployment}
                      inputRef={provinceOfEmpRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="City of employment"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientWorkInCanadaInfos[0]?.cityOfEmployment}
                      inputRef={cityOfEmpRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Job Title"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={client?.clientWorkInCanadaInfos[0]?.jobTitle}
                      inputRef={jobTitleRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}></Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default DetailsOfWorkInCanada;
